"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var FormBaseInput_1 = __importDefault(require("../components/FormBaseInput"));
var FormInputGroup_1 = __importDefault(require("../components/FormInputGroup"));
var FormInput_1 = __importStar(require("../FormInput"));
var NumberStepper_1 = __importDefault(require("../components/NumberStepper"));
var FormField = react_1.default.forwardRef(function (_a, ref) {
    var className = _a.className, id = _a.id, label = _a.label, optional = _a.optional, invalid = _a.invalid, feedback = _a.feedback, helpText = _a.helpText, steps = _a.steps, type = _a.type, onChange = _a.onChange, rtl = _a.rtl, props = __rest(_a, ["className", "id", "label", "optional", "invalid", "feedback", "helpText", "steps", "type", "onChange", "rtl"]);
    var themeRtl = react_1.default.useContext(styled_components_1.ThemeContext).rtl;
    var Tag = type === "number" ? NumberStepper_1.default : FormInput_1.default;
    return (react_1.default.createElement(FormBaseInput_1.default, { className: className, feedback: feedback, helpText: helpText, id: id, invalid: invalid, label: label, optional: optional, rtl: themeRtl || rtl },
        react_1.default.createElement(FormInputGroup_1.default, { type: type, rtl: themeRtl || rtl, plaintext: props.plaintext },
            react_1.default.createElement(Tag, __assign({}, props, { steps: Number(steps), type: type, className: className, id: id, invalid: invalid, onChange: FormInput_1.customChangeEvent(onChange), ref: ref, rtl: themeRtl || rtl })))));
});
FormField.defaultProps = {
    steps: "1"
};
FormField.displayName = "FormField";
exports.default = FormField;
//# sourceMappingURL=index.js.map